import React from 'react';
import PasswordChangeContainer from '../../containers/PasswordChange/PasswordChangeContainer';

function PasswordChangeRequestRoute() : JSX.Element {
  return <PasswordChangeContainer type="request" />;
}

export default PasswordChangeRequestRoute;
